export default __webpack_public_path__ + "static/media/64-min.c8f3be78.jpg";